import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';
import { useHistory, Redirect } from 'react-router-dom';
import GetAppIcon from '@material-ui/icons/GetApp';
import OpenChatBot from '~/components/layout/Chatbot';
import { analytics, logEvent }  from "~/services/firebaseConfig";

import {
  Container,
  PageTitleContainer,
  PageTitle,
  Content,
  BackIcon,
  ValeIcon,
  StatusIcon,
  ContainerItems,
  Left,
  Middle,
  Right,
  FilterButton,
  Close,
  BoxStatus,
  FilterButtonWhite,
  FilterMobile,
  First,
  Second,
  PeriodSize,
  HeaderContainer,
  PageContainer,
  IconLoadingMore,
  AlignNoVoucher,
  HeaderMobileContainer,
  DivisionDowload,
  DivisionTitleVales,
  DivisionFilters,
  InsertCode,
  DivisionChangeCode,
  RightCode,
  CodeMobile
} from './styles';
import '~/components/styles/Global.css';
import { NextPage, NextPageContainer } from '~/pages/Bankslips/styles';
import valegasicon from '~/assets/images/vale-gas.svg';
import filtericon from '~/assets/images/filter.svg';
import back from '~/assets/images/arrow.svg';
import api from '~/services/api';
import Loading from '~/components/layout/Loading';
import SideBar from '~/components/layout/Sidebar';
import Header from '~/components/layout/Header';
import Item from '~/components/pages/GasVoucher/ItemList';
import ModalFilter from '~/components/pages/GasVoucher/ModalFilter';
import HeaderMobile from '~/components/layout/HeaderOld';
import { verifyRoles } from '~/utils/functions/verifyRoles';
import ModalDownload from "~/components/layout/ModalDownload";
import clipboard from "~/assets/images/clipboard.png"

export const typesPendenciesOrBonificate = {
  2: "PENDENTE_BONIFICACAO",
  3: "PENDENTE_BONIFICACAO",
  4: "BONIFICADO",
  5: "BONIFICADO"
}

export const Types = {
  DAYS_90: 'DAYS_90',
  DAYS_60: 'DAYS_60',
  DAYS_30: 'DAYS_30',
  DAYS_15: 'DAYS_15',
  DAYS_7: 'DAYS_7',
  DAYS_1: 'DAYS_1',
};

export default function GasVoucherList() {
  const vouchersReducer = useSelector(state => state.vouchersReducer);
  const economicGroupReducer = useSelector(state => state.economicGroupReducer);
  const dispatch = useDispatch();
  const history = useHistory();

  const [vouchers, setVouchers] = useState([]);
  const [vouchersIndex, setVouchersIndex] = useState(0);
  const [loadingPage, setLoadingPage] = useState(true);
  const [beginDate, setBeginDate] = useState(moment().format('YYYY-MM-DD'));
  const [endDate, setEndDate] = useState(moment().format('YYYY-MM-DD'));
  const [showModal, setShowModal] = useState(false);
  const [beginDateFilter, setBeginDateFilter] = useState('');
  const [endDateFilter, setEndDateFilter] = useState('');
  const [updateRequest, setUpdateRequest] = useState(false);
  const [addVouchesIndex, setAddVouchesIndex] = useState(10);
  const [vouchersInView, setVouchersInView] = useState([]);
  const [notNext, setNotNext] = useState(false);
  const [loadingNext, setLoadingNext] = useState(false);
  const [lengthBelow20, setLengthBelow20] = useState(false);
  const [cacheKey, setCacheKey] = useState('');
  const [modalDowload, setmodalDowload] = useState(false);
  const [storeId, setStoreId] = useState('');
  const [codeChanged, setCodeChanged] = useState('');

  const roles = useSelector(state => state.rolesReducer.roles);

  function activeModal() {
    if (showModal) {
      setShowModal(false);
    } else {
      setShowModal(true);
    }
  }

  function activebeginDate(beginDate) {
    setBeginDateFilter(beginDate);
  }

  function activeEndDate(endDate) {
    setEndDateFilter(endDate);
  }

  const setViewVouchers = (data, index, bonified) => {
    if (data.length < 20 && data !== 0) {
      setVouchersInView(data);
      setLengthBelow20(true);
    } else {
      setLengthBelow20(false);
      let usedData = vouchers;
      let newIndex = vouchersIndex;
      let indexToCompare = addVouchesIndex;
      if (vouchers.length < 1 || vouchers.length !== data.length) {
        if (data === 0) {
          usedData = vouchers;
        } else {
          usedData = data;
        }
      }
      if (indexToCompare < index) {
        indexToCompare = index;
      }
      let arrayToOrdersInView = [];
      while (newIndex < indexToCompare) {
        arrayToOrdersInView.push(usedData[newIndex]);
        newIndex++;
      }
      setVouchersIndex(newIndex);
      let concatArray = [];
      if (bonified) {
        concatArray = concatArray.concat(arrayToOrdersInView);
      } else {
        concatArray = vouchersInView.concat(arrayToOrdersInView);
      }
      setVouchers(concatArray);
      setVouchersInView(concatArray);
      setLoadingNext(false);
    }
  };

  async function request(code='') {
    setVouchers([]);
    setVouchersInView([]);
    setAddVouchesIndex(10);
    setVouchersIndex(0);
    setLengthBelow20(false);
    const header = {
      'Content-Type': 'application/json',
      access_token: localStorage.getItem('access_token'),
    };
    const parameters = {
      method: 'GET',
      headers: header,
    };

    let storeDocument = localStorage.getItem('storeDocument');
    while (storeDocument.length < 15) {
      storeDocument = `0${storeDocument}`;
    }

    let url = `/residential/store/v1/voucher/user-me/find-voucher-store`;
    url = `${url}?organization-id=${localStorage.getItem('organizationId')}`;
    url = `${url}&store-document=${storeDocument}`;
    url = `${url}&customer-id=${localStorage.getItem('customerId')}`;
    url = `${url}&address-id=${localStorage.getItem('addressId')}`;
    url = `${url}&situation=${
      vouchersReducer.situation
        ? vouchersReducer.situation
        : 'PENDENTE_BONIFICACAO'
    }`;
    if (vouchersReducer.filterDate.begin !== '') {
      url = `${url}&end-date=${vouchersReducer.filterDate.end}`;
      url = `${url}&begin-date=${vouchersReducer.filterDate.begin}`;
    } else {
      url = `${url}&end-date=${endDate}`;
      url = `${url}&begin-date=${beginDate}`;
    }
    if (code) {
      url = `${url}&voucher-code=${code}`;
    }

    await api
      .get(url, parameters)
      .then(async res => {
        setShowModal(false);
        setCacheKey(res.data.length > 0 ? res.headers['x-file-cache-key'] : '');
        dispatch({ type: 'SET_VOUCHERS', vouchers: res.data });
        setVouchers(res.data);
        setVouchersInView([]);
        if (res.data.length > 0) {
          setViewVouchers(res.data, 0, true);
        } else {
          setLengthBelow20(true);
        }
        setLoadingPage(false);
      })
      .catch(async err => {
        setLoadingPage(false);
        const erro = err.response;
        if (erro) {
          if (err.response.status !== 401) {
            if (err.response.data[0].message) {
              if (
                err.response.data[0].message ===
                'O campo end-date tem o formato ou valor inválido.'
              ) {
                toast.error('Data final inválida');
              } else if (
                err.response.data[0].message ===
                'O campo begin-date tem o formato ou valor inválido.'
              ) {
                toast.error('Data inicial inválida');
              } else {
                toast.error(err.response.data[0].message);
              }
            }
          }
        }
      });
  }

  async function requestWithVoucherCode(code) {
    setCodeChanged(code);
    setVouchersInView([]);

    if (code.length === 7 || code.length >= 10) {
      setLoadingPage(true);
      request(code);
    }
    if (code.length === 0) {
      setLoadingPage(true);
      await request();
    }
  }

  useEffect(() => {
    setVouchersInView([]);
    setLengthBelow20(true);
    setVouchersIndex(0);

    const selectedStoreReducer = economicGroupReducer.selectedStore ? economicGroupReducer.selectedStore.storeId : "";

    if (storeId !== selectedStoreReducer) {
      setCodeChanged("");
    }

    if (!codeChanged.length || storeId !== selectedStoreReducer){
      if (!vouchersReducer.situation) {
        dispatch({ type: 'CHANGE_SITUATION', situation: 'PENDENTE_BONIFICACAO' });
      } else {
        setLoadingPage(true);
        if (vouchersReducer.filterDate.begin !== '') {
          setBeginDate(vouchersReducer.filterDate.begin);
          setEndDate(vouchersReducer.filterDate.end);
        }
        async function changeRequest() {
          await request();
        }
        changeRequest();
      }
    }
  }, [vouchersReducer.situation, economicGroupReducer.selectedStore, updateRequest]);

  useEffect(() => {
    if (storeId === '') {
      setStoreId(economicGroupReducer.selectedStore ? economicGroupReducer.selectedStore.storeId : "");
      if(economicGroupReducer.selectedStore) {
        setUpdateRequest(!updateRequest);
      }
    } else {
      if (storeId !== economicGroupReducer.selectedStore.storeId) {
        setStoreId(economicGroupReducer.selectedStore.storeId);
        setUpdateRequest(!updateRequest);
      }
    }
  }, [economicGroupReducer.selectedStore]);

  async function changeFilter(type) {
    await setShowModal(false);
    switch (type) {
      case Types.DAYS_30:
        setBeginDate(moment().subtract(30, 'days').format('YYYY-MM-DD'));
        setEndDate(moment().format('YYYY-MM-DD'));
        dispatch({
          type: 'SET_DATE',
          begin: moment().subtract(30, 'days').format('YYYY-MM-DD'),
          end: moment().format('YYYY-MM-DD'),
        });
        break;
      case Types.DAYS_15:
        setBeginDate(moment().subtract(15, 'days').format('YYYY-MM-DD'));
        setEndDate(moment().format('YYYY-MM-DD'));
        dispatch({
          type: 'SET_DATE',
          begin: moment().subtract(15, 'days').format('YYYY-MM-DD'),
          end: moment().format('YYYY-MM-DD'),
        });
        break;
      case Types.DAYS_7:
        setBeginDate(moment().subtract(7, 'days').format('YYYY-MM-DD'));
        setEndDate(moment().format('YYYY-MM-DD'));
        dispatch({
          type: 'SET_DATE',
          begin: moment().subtract(7, 'days').format('YYYY-MM-DD'),
          end: moment().format('YYYY-MM-DD'),
        });
        break;
      case Types.DAYS_1:
        setBeginDate(moment().format('YYYY-MM-DD'));
        setEndDate(moment().format('YYYY-MM-DD'));
        dispatch({
          type: 'SET_DATE',
          begin: moment().format('YYYY-MM-DD'),
          end: moment().format('YYYY-MM-DD'),
        });
        break;
    }
    await setVouchersIndex(0);
    await setBeginDateFilter('');
    await setEndDateFilter('');
    await setUpdateRequest(!updateRequest);
  }

  async function changeFilterDate() {
    setVouchersIndex(0);
    let beginAfter30Days = moment(beginDateFilter, 'DD/MM/YYYY').add(
      30,
      'days',
    );
    if (beginDateFilter === '' || endDateFilter === '') {
      toast.error('É necessário digitar a data inicial e final');
    } else if (moment(endDateFilter, 'DD/MM/YYYY') > beginAfter30Days) {
      toast.error('O período informado deve ser menor ou igual a 30 dias');
      setEndDateFilter(moment(beginAfter30Days).format('DD/MM/YYYY'));
    } else {
      if (
        moment(beginDateFilter, 'YYYY-MM-DD').format('DD/MM/YYYY') ===
        'Invalid date'
      ) {
        toast.error('Escreva uma data inicial válida para continuar');
      } else if (
        moment(endDateFilter, 'YYYY-MM-DD').format('DD/MM/YYYY') ===
        'Invalid date'
      ) {
        toast.error('Escreva uma data final válida para continuar');
      } else {
        await setBeginDate(
          moment(beginDateFilter, 'DD/MM/YYYY').format('YYYY-MM-DD'),
        );
        await setEndDate(
          moment(endDateFilter, 'DD/MM/YYYY').format('YYYY-MM-DD'),
        );
        dispatch({
          type: 'SET_DATE',
          begin: moment(beginDateFilter, 'DD/MM/YYYY').format('YYYY-MM-DD'),
          end: moment(endDateFilter, 'DD/MM/YYYY').format('YYYY-MM-DD'),
        });
        await setUpdateRequest(!updateRequest);
      }
    }
  }

  function changeSituation(situation) {
    setVouchers([]);
    setVouchersInView([]);
    dispatch({
      type: 'CHANGE_SITUATION',
      situation,
    });
  }

  function dowloadItems() {
    if (cacheKey !== '') {
      const header = {
        'Content-Type': 'application/json',
        access_token: localStorage.getItem('access_token'),
      };
      const parameters = {
        headers: header,
        responseType: 'blob',
      };

      let urlSave = `/residential/store/v1/voucher/spreadsheet-voucher-store/${cacheKey}`;
      api
        .get(urlSave, parameters)
        .then(res => {
          setmodalDowload(false);
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `vale-gas/${beginDate}.xlsx`);
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
        })
        .catch(err => {
        });
    } else {
      toast.error(
        'Selecione um período com pelo menos 1 vale para fazer o download',
      );
    }
  }

  return (
    <PageContainer>
      {verifyRoles(roles, 'VALE_GAS') ? (
        <>
          <SideBar menuSelected={'Minha Conta'}>
            <HeaderContainer>
              <Header
                userName={localStorage.getItem('userName')}
                userEmail={localStorage.getItem('userEmail')}
                storeName={localStorage.getItem('storeName')}
                storeDocument={localStorage.getItem('storeDocument')}
              />
            </HeaderContainer>
            <HeaderMobileContainer>
              <HeaderMobile />
            </HeaderMobileContainer>
            <Container>
              <ModalFilter
                activeModal={activeModal}
                activebeginDate={activebeginDate}
                activeEndDate={activeEndDate}
                changeFilter={changeFilter}
                changeFilterDate={changeFilterDate}
                showModal={showModal}
                beginDateFilter={beginDateFilter}
                endDateFilter={endDateFilter}
                loadingPage={loadingPage}
              />
              <Content>
                <BackIcon>
                  <img
                    style={{marginRight: "20px"}}
                    src={back}
                    alt="Ícone para voltar"
                    onClick={() => {
                      history.push('/valegas');
                    }}
                  />
                </BackIcon>
                <PageTitleContainer>
                  <Left>
                    <ValeIcon src={valegasicon} alt="Ícone do vale gás" />
                    <PageTitle>Vale Gás</PageTitle>
                  </Left>
                </PageTitleContainer>
                <PageTitleContainer>
                  <DivisionFilters>
                    <Middle>
                      <StatusIcon src={filtericon} alt="Ícone de filtro" />
                      <PeriodSize>Status:</PeriodSize>
                      {vouchersReducer.situation === 'BONIFICADO' ? (
                        <>
                          <FilterButtonWhite
                            onClick={() =>
                              changeSituation('PENDENTE_BONIFICACAO')
                            }
                          >
                            Pendentes de bonificação
                          </FilterButtonWhite>
                          <FilterButton margin={'.5rem 1rem 0 0'}>
                            Bonificados
                          </FilterButton>
                        </>
                      ) : (
                        <>
                          <FilterButton>Pendentes de bonificação</FilterButton>
                          <FilterButtonWhite
                            onClick={() => changeSituation('BONIFICADO')}
                          >
                            Bonificados
                          </FilterButtonWhite>
                        </>
                      )}
                    </Middle>

                    <Right style={{ margin: '0rem 2rem 0 25px' }}>
                      <StatusIcon src={filtericon} alt="Ícone de filtro" />
                      <PeriodSize>Período:</PeriodSize>
                      <FilterButton onClick={() => setShowModal(true)}>
                        {beginDate === 'Invalid date'
                          ? moment().format('DD/MM/YYYY')
                          : moment(beginDate, 'YYYY-MM-DD').format(
                              'DD/MM/YYYY',
                            )}{' '}
                        -{' '}
                        {endDate === 'Invalid date'
                          ? moment().format('DD/MM/YYYY')
                          : moment(endDate, 'YYYY-MM-DD').format('DD/MM/YYYY')}
                        <Close>x</Close>
                      </FilterButton>
                    </Right>

                    <RightCode>
                      <StatusIcon src={filtericon} alt="Ícone de filtro" />
                      <PeriodSize>Filtrar:</PeriodSize>
                      <DivisionChangeCode>
                        <InsertCode>
                          <input
                            maxlength="100"
                            value={codeChanged}
                            onChange={(e) => requestWithVoucherCode(e.target.value)}
                            placeholder="Código de autorização ou n° do vale"
                          />
                        </InsertCode>
                      </DivisionChangeCode>
                    </RightCode>

                    <FilterMobile>
                      <First>
                        <StatusIcon src={filtericon} alt="Ícone de filtro" />
                        <PeriodSize>Período:</PeriodSize>
                        <FilterButton onClick={() => setShowModal(true)}>
                          {moment(beginDate, 'YYYY-MM-DD').format('DD/MM/YYYY')} -{' '}
                          {moment(endDate, 'YYYY-MM-DD').format('DD/MM/YYYY')}
                          <Close>x</Close>
                        </FilterButton>
                      </First>
                      <Second>
                        <BoxStatus>
                          <StatusIcon src={filtericon} alt="Ícone de filtro" />
                          <span>Status:</span>
                        </BoxStatus>

                        {vouchersReducer.situation === 'BONIFICADO' ? (
                          <>
                            <FilterButtonWhite
                              onClick={() =>
                                changeSituation('PENDENTE_BONIFICACAO')
                              }
                            >
                              Pendentes de bonificação
                            </FilterButtonWhite>
                            <FilterButton>Bonificados</FilterButton>
                          </>
                        ) : (
                          <>
                            <FilterButton>Pendentes de bonificação</FilterButton>
                            <FilterButtonWhite
                              onClick={() => changeSituation('BONIFICADO')}
                            >
                              Bonificados
                            </FilterButtonWhite>
                          </>
                        )}
                      </Second>
                      <CodeMobile>
                        <StatusIcon src={filtericon} alt="Ícone de filtro" />
                        <PeriodSize>Filtrar:</PeriodSize>
                        <DivisionChangeCode>
                          <InsertCode>
                          <input
                            maxlength="100"
                            value={codeChanged}
                            onChange={(e) => requestWithVoucherCode(e.target.value)}
                            placeholder="Código de autorização ou n° do vale"
                          />
                        </InsertCode>
                        </DivisionChangeCode>
                      </CodeMobile>
                      <DivisionDowload>
                        {!codeChanged.length && (
                          <a
                            hasVoucher={vouchersInView.length > 0}
                            href="#"
                            onClick={e => {
                              e.preventDefault();
                              if(vouchersInView.length < 1) {
                                toast.error("Nenhum vale disponível para Download");
                              } else {
                                setmodalDowload(true);
                              }
                            }}
                          >
                            <GetAppIcon />
                            Download
                          </a>
                        )}
                      </DivisionDowload>
                    </FilterMobile>
                  </DivisionFilters>
                </PageTitleContainer>
                {loadingPage ? (
                  <Loading />
                ) : (
                  <>
                    <PageTitleContainer>
                      <DivisionTitleVales>
                        <img
                          src={clipboard}
                          alt="Ícone do relatório"
                        />
                        <h3>Relatório Meus Vales</h3>
                      </DivisionTitleVales>
                      <Left />
                      <Middle />
                      <Right>
                        <DivisionDowload>
                          {!codeChanged.length && (
                            <a
                              hasVoucher={vouchersInView.length > 0}
                              href="#"
                              onClick={e => {
                                e.preventDefault();
                                if(vouchersInView.length < 1) {
                                  toast.error("Nenhum vale disponível para Download");
                                } else {
                                  setmodalDowload(true);
                                }
                              }}
                            >
                              <GetAppIcon />
                              Download
                            </a>
                          )}
                        </DivisionDowload>
                      </Right>
                    </PageTitleContainer>
                    {vouchersInView.length < 1 ? (
                      <AlignNoVoucher>
                        <span>Nenhum vale encontrado</span>
                      </AlignNoVoucher>
                    ) : (
                      <ContainerItems>
                        {vouchersInView.map(element => {
                          return (
                          <Item
                            voucher={{
                              ...element,
                              status:
                                vouchersReducer.situation === 'PENDENTE_BONIFICACAO'
                                  ? 'Pendente de bonificação'
                                  : 'Bonificado',
                            }}
                          />
                        )} )}
                        {lengthBelow20 ? null : (
                          <NextPageContainer content="center">
                            {notNext ? null : (
                              <NextPage
                                onClick={() => {
                                  logEvent(analytics, 'carregar_mais_vale_gas');
                                  if (vouchersIndex >= vouchersReducer.vouchers.length) {
                                    setNotNext(true);
                                  } else {
                                    setLoadingNext(true);
                                    let newIndex = addVouchesIndex + 10;
                                    setAddVouchesIndex(newIndex);
                                    setViewVouchers(0, newIndex);
                                  }
                                }}
                              >
                                {loadingNext ? (
                                  <IconLoadingMore className="fa fa-spinner fa-pulse fa-3x fa-fw" />
                                ) : (
                                  <>
                                    {vouchersInView.length < 1
                                      ? null
                                      : 'Carregar mais...'}
                                  </>
                                )}
                              </NextPage>
                            )}
                          </NextPageContainer>
                        )}
                      </ContainerItems>
                    )}
                  </>
                )}
              </Content>
            </Container>
            <ModalDownload
              modalDowload={modalDowload}
              setmodalDowload={setmodalDowload}
              dowloadItems={dowloadItems}
              vouchers={vouchersInView}
            />
          </SideBar>
        </>
      ) : (
        <Redirect to="/portal" />
      )}
      <OpenChatBot />
    </PageContainer>
  );
}
